<template>
    <div class="surface-overlay px-6 shadow-2 flex flex-column relative lg:static">

        <!-- ROW 1: Header -->
        <div class="py-3 flex align-items-center justify-content-between" style="min-height: 80px">

            <img src="images/blocks/logos/logo.simplyinvesting.rev3.png"
                 alt="Simply Investing" height="38" class="mr-0 lg:mr-6"/>

            <!-- Mobile toggle -->
            <a
                v-ripple
                class="cursor-pointer block lg:hidden text-700 mt-1 p-ripple"
                v-styleclass="{
                  selector: '@next',
                  enterClass: 'hidden',
                  leaveToClass: 'hidden',
                  hideOnOutsideClick: true}">
                <i class="pi pi-bars text-4xl"></i>
            </a>

            <!-- Main Navigation Wrapper -->
            <div
                class="navbar-wrapper align-items-center flex-grow-1 justify-content-between
                hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">
                <!-- existing menu unchanged -->

                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">

                    <li>
                        <a v-ripple
                           @click="processHome"
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900
                            hover:surface-100 font-medium border-round cursor-pointer">
                            <span>Home</span>
                        </a>
                    </li>

                    <li v-for="section in menu1" :key="section.label" class="lg:relative">

                        <a
                            v-ripple
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer transition-colors"
                            v-styleclass="{
                              selector: '@next',
                              enterClass: 'hidden',
                              enterActiveClass: 'scalein',
                              leaveToClass: 'hidden',
                              leaveActiveClass: 'fadeout',
                              hideOnOutsideClick: true
                            }">
                            <i :class="section.icon + ' mr-2'"></i>
                            <span>{{ section.label }}</span>
                            <i class="pi pi-angle-down ml-1 lg:ml-3"></i>
                        </a>

                        <!-- Dropdown -->
                        <ul class="nav-dropdown list-none py-3 px-6 m-0 lg:px-0 lg:py-0
                     border-round-sm shadow-0 lg:shadow-2 lg:border-1 border-50
                     lg:absolute surface-overlay hidden origin-top w-full w-full md:w-13rem lg:w-15rem cursor-pointer">

                            <li v-for="item in section.items" :key="item.label">
                                <a
                                    v-ripple
                                    @click="item.action"
                                    class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors cursor-pointer"
                                >
                                    <i :class="item.icon + ' mr-2'"></i>
                                    <span class="font-medium">{{ item.label }}</span>
                                </a>
                            </li>

                        </ul>

                    </li>

                    <li>
                        <a v-ripple
                           @click="processCourse"
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900
                            hover:surface-100 font-medium border-round cursor-pointer">
                            <span>Course</span>
                        </a>
                    </li>

                    <li>
                        <a v-ripple
                           @click="processCommunity"
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900
                            hover:surface-100 font-medium border-round cursor-pointer">
                            <span>Community</span>
                        </a>
                    </li>

                    <li v-for="section in menu2" :key="section.label" class="lg:relative">

                        <a
                            v-ripple
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer transition-colors"
                            v-styleclass="{
                              selector: '@next',
                              enterClass: 'hidden',
                              enterActiveClass: 'scalein',
                              leaveToClass: 'hidden',
                              leaveActiveClass: 'fadeout',
                              hideOnOutsideClick: true
                            }">
                            <i :class="section.icon + ' mr-2'"></i>
                            <span>{{ section.label }}</span>
                            <i class="pi pi-angle-down ml-1 lg:ml-3"></i>
                        </a>

                        <!-- Dropdown -->
                        <ul class="nav-dropdown list-none py-3 px-6 m-0 lg:px-0 lg:py-0
                     border-round-sm shadow-0 lg:shadow-2 lg:border-1 border-50
                     lg:absolute surface-overlay hidden origin-top w-full w-full md:w-13rem lg:w-15rem cursor-pointer">

                            <li v-for="item in section.items" :key="item.label">
                                <a
                                    v-ripple
                                    @click="item.action"
                                    class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors cursor-pointer"
                                >
                                    <i :class="item.icon + ' mr-2'"></i>
                                    <span class="font-medium">{{ item.label }}</span>
                                </a>
                            </li>

                        </ul>

                    </li>


                </ul>

                <!-- RIGHT ICONS -->
                <ul
                    class="list-none p-0 m-0 flex lg:align-items-center
                           select-none flex-column lg:flex-row border-top-1 surface-border
                           lg:border-top-none">

                    <li>
                        <a
                            v-ripple
                            @click="processSupport"
                            v-tooltip="'Contact Support'"
                            class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900
                            hover:surface-100 font-medium border-round cursor-pointer transition-colors">
                            <i class="pi pi-info-circle text-2xl"></i>
                        </a>
                    </li>

                    <li>
                        <a
                            v-ripple
                            @click="processLogout"
                            class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center
                               text-600 hover:text-900 hover:surface-100 font-medium
                               border-round cursor-pointer transition-colors">
                            <i class="pi pi-sign-out text-2xl"></i>
                        </a>
                    </li>

                </ul>

            </div>
        </div>

    </div>
</template>


<script>

import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("siLogin");
            return;
        }

        if (this.userStore.user === undefined) {
            this.userStore.clearUser;
            this.$router.push('siLogin');
        } else {
            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                })
        }
    },
    data() {
        return {
            profile: null,
            menu1: [
                {
                    label: "Plan",
                    items: [
                        {label: "Set Goals", action: this.processSetGoals},
                        {label: "Add to Watchlist", action: this.processWatchlistAdd},
                        {label: "Remove from Watchlist", action: this.processWatchlistRemove},
                        {label: "Watchlist", action: this.processWatchlist},
                        {label: "Manage Alerts", action: this.processAlerts},
                    ]
                },

                {
                    label: "Track",
                    items: [
                        {label: "Portfolio Summary", action: this.processPortfolioSummary},
                        {label: "Country Portfolio(s)", action: this.processCountryPortfolio},
                        {label: "Add Stock/Fund", action: this.processTrackAddStock},
                        {label: "Add Other Income", action: this.processTrackAddOtherIncome},
                    ]
                },
                {
                    label: "Achieve",
                    items: [
                        {label: "Achieving my Goals", action: this.processAchievingGoals},
                        {label: "Fee Table", action: this.processFeeTable},
                        {label: "Configure Portfolio Growth Simulator", action: this.processConfigureSimulator},
                        {label: "Portfolio Growth Simulator", action: this.processPortfolioSimulator},
                        {label: "Add Stock/Fund to Mock Portfolio", action: this.processAchieveAddStock},
                        {label: "Add Other Income to Mock Portfolio", action: this.processAchieveAddOtherIncome},
                        {label: "View Mock Portfolio", action: this.processMockPortfolio},
                    ]
                },
                {
                    label: "Analysis",
                    items: [
                        {label: "Basic Search", action: this.processBasicSearch},
                        {label: "Advanced Search", action: this.processAdvancedSearch},
                        {label: "Compare Stocks", action: this.processCompareStocks},
                        {label: "Create New Custom Filter", action: this.processNewCustomFilter},
                        {label: "Manage Custom Filters", action: this.processCustomFilters},
                    ]
                }
            ],
            menu2: [
                {
                    label: "Account",
                    items: [
                        {label: "User Settings", action: this.processUserSettings},
                        {label: "Email Lists", action: this.processEmailLists},
                        {label: "Change Password", action: this.processPassword},
                        {label: "Upgrade/Downgrade Subscription", action: this.processSubscription},
                        {label: "Cancel Subscription", action: this.processCancellation},
                    ]
                },
                {
                    label: "Help",
                    items: [
                        {label: "Getting Started", action: this.processHelp},
                        {label: "12 Rules & SI Criteria", action: this.processRules},
                        {label: "Building Your Portfolio", action: this.processBuildingPortfolio},
                        {label: "Column Definitions", action: this.processColumnDefinitions},
                        {label: "Glossary", action: this.processGlossary},
                        {label: "FAQ", action: this.processFaq},
                    ]
                },
            ]
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processLogout() {
            this.closeAllMenus();

            this.userStore.$reset();
            this.userStore.clearUser();

            this.$router.push('/siLogin');
        },
        processHome() {
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        processSupport() {
            this.closeAllMenus();
            this.safeNavigate('/siSupport');
        },
        processCourse() {
            this.closeAllMenus();
            this.safeNavigate('/siCourse');
        },
        processCommunity() {
            window.open("https://www.linkedin.com/groups/14562007/", '_blank');
        },
        processRules() {
            this.closeAllMenus();
            window.open("https://www.simplyinvesting.com/rules", '_blank');
        },
        processBuildingPortfolio() {
            this.closeAllMenus();
            window.open("https://www.simplyinvesting.com/building-your-portfolio", '_blank');
        },
        processFaq() {
            this.closeAllMenus();
            window.open("https://www.simplyinvesting.com/app-faq", '_blank');
        },
        processHelp() {
            this.closeAllMenus();
            this.safeNavigate('/siHelp');
        },
        processGlossary() {
            this.closeAllMenus();
            this.safeNavigate('/siGlossary');
        },
        processColumnDefinitions() {
            this.closeAllMenus();
            this.safeNavigate('/siColumnDefinitions');
        },
        processSetGoals() {
            this.closeAllMenus();
            this.safeNavigate('/siSetGoals');
        },
        processWatchlist() {
            this.closeAllMenus();
            this.safeNavigate('/siWatchlist');
        },
        processWatchlistAdd() {
            this.closeAllMenus();
            this.safeNavigate('/siWatchlistAdd');
        },
        processWatchlistRemove() {
            this.closeAllMenus();
            this.safeNavigate('/siWatchlistRemove');
        },
        processAlerts() {
            this.closeAllMenus();
            this.safeNavigate('/siAlerts');
        },
        processUserSettings() {
            this.closeAllMenus();
            this.safeNavigate('/siUserSettings');
        },
        processEmailLists() {
            this.closeAllMenus();
            this.safeNavigate('/siEmailLists');
        },
        processPassword() {
            this.closeAllMenus();
            this.safeNavigate('/siPassword');
        },
        processSubscription() {
            this.closeAllMenus();
            this.safeNavigate('/siSubscription');
        },
        processCancellation() {
            this.closeAllMenus();
            this.safeNavigate('/siCancellation');
        },
        processPortfolioSummary() {
            this.closeAllMenus();
            this.safeNavigate('/siPortfolioSummary');
        },
        processCountryPortfolio() {
            this.closeAllMenus();
            this.safeNavigate('/siCountryPortfolio');
        },
        processTrackAddStock() {
            this.closeAllMenus();
            this.safeNavigate('/siTrackAddStock');
        },
        processTrackAddOtherIncome() {
            this.closeAllMenus();
            this.safeNavigate('/siTrackAddOtherIncome');
        },
        processAchievingGoals() {
            this.closeAllMenus();
            this.safeNavigate('/siAchievingGoals');
        },
        processFeeTable() {
            this.closeAllMenus();
            this.safeNavigate('/siFeeTable');
        },
        processConfigureSimulator() {
            this.closeAllMenus();
            this.safeNavigate('/siConfigureSimulator');
        },
        processPortfolioSimulator() {
            this.closeAllMenus();
            this.safeNavigate('/siPortfolioSimulator');
        },
        processAchieveAddStock() {
            this.closeAllMenus();
            this.safeNavigate('/siAchieveAddStock');
        },
        processAchieveAddOtherIncome() {
            this.closeAllMenus();
            this.safeNavigate('/siAchieveAddOtherIncome');
        },
        processMockPortfolio() {
            this.closeAllMenus();
            this.safeNavigate('/siMockPortfolio');
        },
        processBasicSearch() {
            this.closeAllMenus();
            this.safeNavigate('/siBasicSearch');
        },
        processAdvancedSearch() {
            this.closeAllMenus();
            this.safeNavigate('/siAdvancedSearch');
        },
        processCompareStocks() {
            this.closeAllMenus();
            this.safeNavigate('/siCompareStocks');
        },
        processNewCustomFilter() {
            this.closeAllMenus();
            this.safeNavigate('/siNewCustomFilter');
        },
        processCustomFilters() {
            this.closeAllMenus();
            this.safeNavigate('/siCustomFilters');
        }
    }
}
</script>

<style scoped>
/* Raise entire top navigation bar ABOVE all content */
.navbar-wrapper {
    position: relative;
    z-index: 9999 !important;
}

/* Ensure dropdown menus are on top as well */
.nav-dropdown {
    position: absolute;
    z-index: 10000 !important;
}

</style>
